import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-icon',
  templateUrl: './icon.html',
  styleUrl: './icon.scss',
  standalone: true,
})

export class Icon {
  @Input({ required: true }) name!: string;
}
